import { ShieldCheck, Download, Link2, Lock, MonitorCheck, CheckCircle2, Wrench, Clock, FileCheck } from "lucide-react";

function resolveGuardSetupUrl() {
  // 🛡️ تم إضافة الرابط المباشر الخاص بك افتراضياً هنا
  const raw = (process.env.REACT_APP_GUARD_SETUP_URL || "https://drive.google.com/drive/folders/1JuOBGwl-IdnrFPZbypbUtebSer6MPAsT?usp=sharing").trim();
  if (!raw) return "";

  const driveMatch = raw.match(/\/d\/([a-zA-Z0-9_-]{10,})\//);
  if (driveMatch?.[1]) {
    return `https://drive.google.com/uc?export=download&id=${driveMatch[1]}`;
  }

  const driveOpenMatch = raw.match(/[?&]id=([a-zA-Z0-9_-]{10,})/);
  if (driveOpenMatch?.[1]) {
    return `https://drive.google.com/uc?export=download&id=${driveOpenMatch[1]}`;
  }

  if (raw.includes("drive.google.com") || raw.startsWith("http")) {
    return raw;
  }

  return "";
}

function Step({ index, title, desc }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-[#111113]/90 p-5 shadow-xl transition-all duration-300 hover:border-emerald-500/30">
      <div className="flex items-start gap-4">
        <div className="h-10 w-10 rounded-xl bg-emerald-500/15 text-emerald-400 border border-emerald-500/30 grid place-items-center font-display font-black text-base shrink-0 shadow-sm">
          {index}
        </div>
        <div>
          <h3 className="font-display font-black text-base text-white">{title}</h3>
          <p className="mt-1 text-xs sm:text-sm text-white/65 leading-relaxed">{desc}</p>
        </div>
      </div>
    </div>
  );
}

export default function RivalsGuardPage() {
  const guardSetupUrl = resolveGuardSetupUrl();

  return (
    <div className="space-y-8" dir="rtl" data-testid="rivalsguard-page">
      {/* 🛡️ الهيدر الرئيسي */}
      <section className="rounded-3xl border border-emerald-500/30 bg-[radial-gradient(circle_at_20%_20%,rgba(16,185,129,0.12),transparent_45%),linear-gradient(135deg,rgba(17,17,19,0.96),rgba(11,11,13,0.92))] p-6 sm:p-8 shadow-2xl relative overflow-hidden">
        <div className="absolute top-0 right-0 w-96 h-96 bg-emerald-500/5 rounded-full blur-3xl pointer-events-none" />
        
        <div className="relative flex items-start gap-4">
          <div className="h-12 w-12 rounded-2xl bg-emerald-500/20 text-emerald-400 border border-emerald-500/40 grid place-items-center shrink-0 shadow-md">
            <ShieldCheck size={26} />
          </div>
          <div className="flex-1">
            <h1 className="font-display font-black text-2xl sm:text-4xl text-white leading-tight">
              RivalsGuard — نظام الحماية والنزاهة للبطولات
            </h1>
            <p className="mt-2 text-white/70 text-sm sm:text-base leading-relaxed max-w-3xl">
              تطبيق حماية مخصص لضمان بيئة منافسة عادلة وخالية من برامج التعديل أو التلاعب بالشبكة. يتكامل البرنامج أوتوماتيكياً مع غرفة المباراة في المنصة مع دعم كامل للأجهزة المعتمدة.
            </p>
          </div>
        </div>

        {/* 📥 أزرار التحميل والتوجيه */}
        <div className="mt-6 flex flex-wrap items-center gap-3">
          {guardSetupUrl ? (
            <a
              href={guardSetupUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="rivalsguard-download-btn"
              className="inline-flex items-center gap-2 rounded-xl bg-emerald-400 text-black px-5 py-3 font-black text-xs hover:bg-emerald-300 transition shadow-[0_0_20px_rgba(16,185,129,0.4)]"
            >
              <Download size={16} /> تحميل برنامج RivalsGuard (Google Drive)
            </a>
          ) : (
            <div className="inline-flex items-center gap-2 rounded-xl border border-amber-500/30 bg-amber-500/10 text-amber-300 px-4 py-3 text-xs font-bold">
              <Download size={15} /> رابط التحميل المباشر يتوفر أثناء بداية البطولات.
            </div>
          )}

          {/* 🛠️ زر تثبيت بروتوكول ويندوز الاحتياطي */}
          <a
            href="/register_rivalsguard_protocol.reg"
            download="register_rivalsguard_protocol.reg"
            className="inline-flex items-center gap-2 rounded-xl border border-emerald-500/30 bg-emerald-500/10 text-emerald-300 px-4 py-3 text-xs font-bold hover:bg-emerald-500/20 transition shadow-sm"
            title="حمل هذا الملف واضغطه مرتين لو لم يفتح البرنامج أوتوماتيكياً من المتصفح"
          >
            <Wrench size={15} /> ملف إصلاح ربط المتصفح (Protocol Fix)
          </a>

          <a
            href="/matches"
            className="inline-flex items-center gap-2 rounded-xl border border-white/10 bg-white/5 text-white/80 px-4 py-3 hover:bg-white/10 transition text-xs font-bold"
          >
            <Link2 size={15} /> الانتقال لصفحة المباريات
          </a>
        </div>
      </section>

      {/* 🚀 خطوات التشغيل */}
      <section className="grid lg:grid-cols-3 gap-4">
        <Step
          index="1"
          title="تثبيت البرنامج"
          desc="حمّل ملف RivalsGuard وثبّته على جهازك. يُفضل تشغيل ملف الربط (Protocol Fix) لمرة واحدة فقط لربطه بالمتصفح بشكل سليم."
        />
        <Step
          index="2"
          title="الانضمام للمباراة"
          desc="ادخل لصفحة مباراتك في منصة Rivals واضغط على زر تفعيل الحماية (RivalsGuard) ليتم تشغيل البرنامج والاتصال بغرفتك تلقائياً."
        />
        <Step
          index="3"
          title="تأكيد الجاهزية 🟢"
          desc="سيظهر وسم الحماية المفعّلة بجانب اسمك في غرفة اللوبي، وتتحول المباراة تلقائياً إلى حالة الجاهزية الكاملة للبدء."
        />
      </section>

      {/* ⚙️ آلية العمل وحفظ السجلات */}
      <section className="grid md:grid-cols-2 gap-4">
        <div className="rounded-3xl border border-white/10 bg-[#111113]/90 p-6 space-y-4 shadow-xl">
          <h2 className="font-display font-black text-xl text-white flex items-center gap-2.5">
            <MonitorCheck size={20} className="text-emerald-400" /> كيف يعمل أثناء المباريات؟
          </h2>
          <ul className="space-y-3 text-xs sm:text-sm text-white/75 leading-relaxed">
            <li className="flex items-start gap-2.5">
              <CheckCircle2 size={16} className="mt-0.5 text-emerald-400 shrink-0" />
              <span>فحص خفيف وصامت بدون استهلاك لموارد المعالج أو كرت الشاشة (استهلاك المعالج أقل من 0.1%).</span>
            </li>
            <li className="flex items-start gap-2.5">
              <CheckCircle2 size={16} className="mt-0.5 text-emerald-400 shrink-0" />
              <span>يتصل مباشرة بالسيرفر عبر نبضات أمان مشفرة للتأكد من استمرار سلامة الجلسة طوال اللعب.</span>
            </li>
            <li className="flex items-start gap-2.5">
              <CheckCircle2 size={16} className="mt-0.5 text-emerald-400 shrink-0" />
              <span>ينتهي الاتصال تماماً وبشكل آمن بمجرد خروجك أو إغلاقك لصفحة المباراة.</span>
            </li>
          </ul>
        </div>

        {/* 📦 حماية السجلات 24 ساعة */}
        <div className="rounded-3xl border border-gold-500/30 bg-gradient-to-b from-gold-500/10 via-[#111113]/90 to-[#111113]/90 p-6 space-y-3.5 shadow-xl">
          <h2 className="font-display font-black text-xl text-white flex items-center gap-2.5">
            <Clock size={20} className="text-gold-400" /> أرشيف وحفظ السجلات (24h Logs)
          </h2>
          <p className="text-xs sm:text-sm text-white/75 leading-relaxed">
            لحماية حقوق المتنافسين، يتم حفظ سجل الجلسة والأدلة بشكل مشفر ومؤقت لمدة <strong>24 ساعة فقط</strong> بعد نهاية المباراة لتستطيع الإدارة مراجعة أي اعتراض أو طعن يدوياً بكل شفافية.
          </p>
          <div className="flex items-center gap-2.5 text-xs text-gold-300 bg-gold-500/10 p-3 rounded-2xl border border-gold-500/20 font-bold">
            <FileCheck size={18} className="shrink-0 text-gold-400" />
            <span>تُحذف جميع الملفات تلقائياً وبشكل نهائي من السيرفر فور انقضاء مدة الـ 24 ساعة.</span>
          </div>
        </div>
      </section>

      {/* 🔒 الخصوصية والأمان */}
      <section className="rounded-3xl border border-white/10 bg-[#111113]/90 p-6 space-y-3.5 shadow-xl">
        <h2 className="font-display font-black text-xl text-white flex items-center gap-2.5">
          <Lock size={20} className="text-gold-400" /> سياسة الخصوصية وأمان الألعاب
        </h2>
        <p className="text-xs sm:text-sm text-white/75 leading-relaxed">
          نظام RivalsGuard لا يقوم بحقن أي أكواد داخل ملفات أو ذاكرة اللعبة الرسمية (يعمل بنظام User-Mode Only). هذا يضمن تماماً عدم تعرض حسابك لأي باند أو حظر من أنظمة حماية الألعاب الرسمية مثل Ricochet أو Vanguard.
        </p>
        <p className="text-xs sm:text-sm text-white/75 leading-relaxed">
          التطبيق يقرأ فقط العناوين العامة والخدمات المشبوهة لضمان النزاهة التامة، ولا يستعرض ملفاتك الشخصية أو صورك الخاصة أو بياناتك الحساسة إطلاقاً.
        </p>
      </section>
    </div>
  );
}
